import { Component, OnInit } from '@angular/core';
import { ExpedienteService } from '../../../services/expediente.service';
import { TableColumn } from '../../../dto/util/table-column';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { ExpedienteDndaFiltroDto } from '../../../dto/expediente/expediente-dnda.filtro.dto';
import { ExpedienteDndaDto } from '../../../dto/expediente/expediente-dnda.dto';
import { HistorialExpedienteDndaDto } from '../../../dto/expediente/historial-expediente-dnda.dto';
import { UtilService } from '../../../services/util.service';
import { ModalService } from '../../../services/util/modal.service';
import { SolicitudDocumentosComponent } from '../solicitud-documentos/solicitud-documentos.component';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { Constants } from '../../../constants/constants';
import {EntidadService} from "../../../services/entidad.service";
import {EntidadApiResponse} from "../../../dto/entidad/entidad-response.dto";

@Component({
  selector: 'app-detalle-dnda',
  templateUrl: './detalle-dnda.component.html',
  styleUrl: './detalle-dnda.component.scss',
})
export class DetalleDndaComponent implements OnInit {
  expedienteDndaDto?: ExpedienteDndaDto;
  historialExpediente: HistorialExpedienteDndaDto[] = [];
  idExpediente = 0;
  usuarioCreadorId = 0;
  entidadId = 5;
  entidad!: EntidadApiResponse;
  columns: TableColumn[] = [];
  filtros: FiltroDto<ExpedienteDndaFiltroDto> = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: false,
    ordenarPor: 'Usuario',
    filtros: {},
  };
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  showButton = true;
  isCreator = false;
  public role = '';

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  tableText: any = {};

  guiaText: any = {};
  guiaDNDAText: any = {};
  showGuia:boolean = true;
  constructor(
    private route: ActivatedRoute,
    private expedienteService: ExpedienteService,
    private router: Router,
    private utilService: UtilService,
    private modalService: ModalService,
    private translate: TranslateService,
    private entidadService: EntidadService
  ) {
    this.route.params.subscribe(params => {
      this.idExpediente = params['expedienteId'];
      this.usuarioCreadorId = params['usuarioId'];
    });
    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.role = parseObject.Nombre;
    }
    // Multilenguaje
    combineLatest({
      tabla: this.translate.stream('detalle-DNDA'),
      guias: this.translate.stream('guias-interactivas'),
      guiaDnda: this.translate.stream('guia-DNDA'),
    }).subscribe(({ tabla, guias, guiaDnda }) => {
      // Asignar traducciones a variables
      this.tableText = tabla;
      this.guiaText = guias;
      this.guiaDNDAText = guiaDnda;
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.initColumns();
    this.cargarEntidad();
    this.filtradoExpediente(this.idExpediente);
    this.utilService.watch().subscribe(val => {
      this.showButton = val;
    });
    this.utilService.setIdEntidad(this.entidadId);
    // Se toma la información del usuario que inicia sesión
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.isCreator = infoInicioSesion.idUsuario === +this.usuarioCreadorId;
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaText['expediente-titulo'],
      descripcionPantalla: this.guiaDNDAText['descripcion-pantalla'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaDNDAText['descripcion-pantalla'],
            description: this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#encabezado',
          popover: {
            title: this.guiaDNDAText['encabezado-titulo'],
            description: this.guiaDNDAText['encabezado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crear_solicitud',
          popover: {
            title: this.guiaDNDAText['crear-solicitud-titulo'],
            description: this.guiaDNDAText['crear-solicitud-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico_solicitudes',
          popover: {
            title: this.guiaDNDAText['historico-titulo'],
            description: this.guiaDNDAText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#documentos',
          popover: {
            title: this.guiaDNDAText['documentos-titulo'],
            description: this.guiaDNDAText['documentos-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#barra_busqueda',
          popover: {
            title: this.guiaDNDAText['filtro-titulo'],
            description: this.guiaDNDAText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#marca_tiempo',
          popover: {
            title: this.guiaDNDAText['marca-titulo'],
            description: this.guiaDNDAText['marca-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#usuario',
          popover: {
            title: this.guiaDNDAText['usuario-titulo'],
            description: this.guiaDNDAText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#estado_proceso',
          popover: {
            title: this.guiaDNDAText['estado-titulo'],
            description: this.guiaDNDAText['estado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };
    const isShowGuia = sessionStorage.getItem(Constants.SHOW_GUIA_DETALLE_DNDA) != null ? false : this.showGuia
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (infoInicioSesion.primerInicioSesion && isShowGuia) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
      sessionStorage.setItem(Constants.SHOW_GUIA_DETALLE_DNDA, 'false')
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
  }

  cargarEntidad(): void {
    this.entidadService.obtenerEntidadPorId(this.entidadId).subscribe({
      next: (data) => {
        this.entidad = data;
      },
      error: (error) => console.error('Error al obtener la entidad:', error),
    });
  }


  filtradoExpediente(idExpediente: number) {
    this.expedienteService
      .getExpedientesDnda(idExpediente)
      .subscribe(response => {
        this.expedienteDndaDto = response;
        this.historialExpediente = this.expedienteDndaDto['actuaciones'];
        this.initColumns();
      });
  }

  initColumns() {
    this.columns = [
      {
        field: 'marca_tiempo',
        title: this.tableText['marca'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'marca_tiempo',
        pipe: 'dd/MM/yyyy HH:mm',
      },
      {
        field: 'usuario',
        title: this.tableText['usuario'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'usuario',
      },
      {
        field: 'estado_proceso',
        title: this.tableText['estado'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'estado_proceso',
      },
      {
        field: 'documento',
        title: this.tableText['documento'],
        type: 'text',
        filterable: false,
        sortable: false,
        fieldFilterElement: 'documento',
      },
    ];
  }

  crearAvanceProcesal() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}`,
    ]);
  }

  navigateAvanceProcesalSolicitudes() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}/solicitudes`,
    ]);
  }

  openModal(): void {
    const modalData: any = {
      entidadId: this.entidadId,
      expedienteId: this.idExpediente,
      numeroProceso: this.expedienteDndaDto?.numero_proceso,
    };

    this.modalService.openModal(SolicitudDocumentosComponent, modalData);
  }
}
